<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <v-btn @click="showAdvance = true" color="primary" outline>
          <v-icon>filter_list</v-icon>
          advance search</v-btn
        >
      </div>
      <v-dialog v-model="showAdvance" width="600px" persistent>
        <v-card class="pa-4" style="position: relative">
          <div class="text-xs-right" style="position: absolute; right: 5px; top: 5px">
            <v-btn icon @click="showAdvance = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div class="mb-3" style="font-weight: 600; font-size: 23px">
            <v-icon size="30">search</v-icon>
            Search
          </div>
          <div>Branch</div>
          <div class="mb-2" v-if="filterOptions && filterOptions.branch">
            <multiselect v-model="filter.branch" :options="filterOptions.branch"></multiselect>
          </div>
          <!-- <div>Company</div>
          <div class="mb-2" v-if="filterOptions && filterOptions.company">
            <multiselect v-model="filter.company" :options="filterOptions.company"></multiselect>
          </div> -->
          <div>Gender</div>
          <div class="mb-2" v-if="filterOptions && filterOptions.gender">
            <multiselect v-model="filter.gender" :options="filterOptions.gender"></multiselect>
          </div>
          <div>Work Location</div>
          <div v-if="filterOptions && filterOptions.work_location">
            <multiselect
              v-model="filter.work_location"
              :options="filterOptions.work_location"
            ></multiselect>
          </div>
          <div class="mt-3 text-xs-center">
            <v-btn @click="onClear" :loading="searchloading" outline color="grey">CLEAR</v-btn>
            <v-btn :loading="searchloading" @click="onSearch" depressed color="primary"
              >search</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <div class="mt-4">
        <v-layout row wrap>
          <v-flex xs12 sm5 class="mr-2">
            <div class="text-xs-center titlecentralhr">Function</div>
            <v-card style="min-height: 380px; position: relative">
              <div v-if="!loading">
                <div v-if="series.length" id="chart">
                  <apexchart
                    :key="keydata"
                    type="pie"
                    width="100%"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
                <div
                  v-else
                  style="
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    top: 50%;
                    font-size: 25px;
                    color: grey;
                  "
                >
                  ไม่พบข้อมูล
                </div>
              </div>
              <div v-else>
                <div class="text-xs-center pt-5">
                  <v-progress-circular
                    size="95"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
              </div> </v-card
          ></v-flex>
          <v-flex xs12 sm5>
            <div class="text-xs-center titlecentralhr">Corporate Title</div>
            <v-card style="min-height: 380px; position: relative">
              <div v-if="!loading">
                <div v-if="series2.length" id="chart2">
                  <apexchart
                    :key="keydata"
                    type="pie"
                    width="100%"
                    :options="chartOptions2"
                    :series="series2"
                  ></apexchart>
                </div>
                <div
                  v-else
                  style="
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    top: 50%;
                    font-size: 25px;
                    color: grey;
                  "
                >
                  ไม่พบข้อมูล
                </div>
              </div>
              <div v-else>
                <div class="text-xs-center pt-5">
                  <v-progress-circular
                    size="95"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
              </div> </v-card
          ></v-flex>
          <v-layout row justify-center class="mt-5" style="width: 100%">
            <v-flex xs12 sm5 md5>
              <div class="text-xs-center titlecentralhr">Company</div>
              <v-card style="min-height: 380px; position: relative">
                <div v-if="!loading">
                  <div v-if="series3.length" id="chart2">
                    <apexchart
                      :key="keydata"
                      type="pie"
                      width="100%"
                      :options="chartOptions3"
                      :series="series3"
                    ></apexchart>
                  </div>
                  <div
                    v-else
                    style="
                      position: absolute;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      top: 50%;
                      font-size: 25px;
                      color: grey;
                    "
                  >
                    ไม่พบข้อมูล
                  </div>
                </div>
                <div v-else>
                  <div class="text-xs-center pt-5">
                    <v-progress-circular
                      size="95"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </div> </v-card
            ></v-flex>
          </v-layout>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import VueApexCharts from 'vue-apexcharts'

export default {
  data() {
    return {
      keydata: 0,
      filterOptions: {},
      filter: {
        branch: '',
        company: '',
        gender: '',
        work_location: ''
      },
      loading: false,
      searchloading: false,
      data: '',
      data2: '',
      data3: '',
      series: [],
      series2: [],
      series3: [],
      showAdvance: false,
      chartOptions: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 100,
          offsetY: -20,
          offsetX: 0,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        chart: {
          width: 380,
          height: '400px',
          type: 'pie'
        },
        labels: []
      },
      chartOptions2: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 130,
          offsetY: -20,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        chart: {
          type: 'pie'
        },
        labels: []
      },
      chartOptions3: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 130,
          offsetY: -20,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        chart: {
          type: 'pie'
        },
        labels: []
      }
    }
  },
  components: {
    Multiselect,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    this.loading = true
    await this.getFilter()
    await this.getData()
    this.loading = false
  },
  methods: {
    async onClear() {
      this.searchloading = true
      this.filter = {
        branch: '',
        company: '',
        gender: '',
        work_location: ''
      }
      await this.getData()
      this.searchloading = false
      this.showAdvance = false
    },
    async onSearch() {
      this.searchloading = true
      await this.getData()
      this.searchloading = false
      this.showAdvance = false
    },
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          company: this.filter.company ? this.filter.company : null,
          branch: this.filter.branch ? this.filter.branch : null,
          gender: this.filter.gender ? this.filter.gender : null,
          work_location: this.filter.work_location ? this.filter.work_location : null
        }
        console.log('res')
        api.employeelogindashboard(data, (err, response) => {
          if (response.responsecode == 200) {
            this.data = response.data ? response.data : []
            this.data2 = response.data2 ? response.data2 : []
            this.data3 = response.data3 ? response.data3 : []
            if (this.data.length) {
              this.series = this.data.map((el) => {
                return parseInt(el.total)
              })
              this.chartOptions.labels = this.data.map((el) => {
                return el.functions
              })
            } else {
              this.series = []
            }
            if (this.data2.length) {
              this.series2 = this.data2.map((el) => {
                return parseInt(el.total)
              })
              this.chartOptions2.labels = this.data2.map((el) => {
                return el.corporate_title
              })
            } else {
              this.series2 = []
            }
            if (this.data2.length) {
              this.series3 = this.data3.map((el) => {
                return parseInt(el.total)
              })
              this.chartOptions3.labels = this.data3.map((el) => {
                return el.company
              })
            } else {
              this.series3 = []
            }
            this.keydata++
          }
          resolve()
        })
      })
    },
    getFilter() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        api.employeefilterinfo(data, (err, response) => {
          if (response.responsecode == 200) {
            this.filterOptions = response.data[0]
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.titlecentralhr {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/centralhr/EmployeeInfo.vue